import React from 'react';

export default function OptimisedImage({ image, alt, ...props }) {
	return <picture>
		<source srcSet={image.webp} type="image/webp" />
		<source srcSet={image.jp2} type="image/jp2" /> 
		<img src={image.fallback} alt={alt} {...props}/>
	</picture>;
}